// Итог задачи для владельца: краткий (пишет агент) или, у старых задач, начало подробного отчёта.
import type { Task } from '../types.ts'

/** Задача владельца: поставлена человеком, корневая, не из проверочного прогона. */
export const isOwnerTask = (t: Task): boolean => t.parent_id === null && t.created_by.startsWith('human:') && t.created_by !== 'human:eval'

/** Агенты закончили, владелец ещё не смотрел. */
export const isDoneUnseen = (t: Task): boolean => t.status === 'done' && !t.owner_seen_at && isOwnerTask(t)

/** Первый содержательный абзац markdown-отчёта простым текстом. */
function firstParagraph(md: string, max = 320): string {
  const plain = md
    .replace(/```[\s\S]*?```/g, ' ')
    .split(/\n\s*\n/)
    .map((p) =>
      p
        .split('\n')
        .filter((l) => !/^\s*(#{1,6}\s|\||-{3,}|>)/.test(l))
        .join(' ')
        .replace(/\*\*|__|`/g, '')
        .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')
        .replace(/^\s*[-*]\s+/, '')
        .replace(/\s+/g, ' ')
        .trim(),
    )
    .find((p) => p.length >= 25 && !/^(что сделано|итог|результат)[^.]{0,20}:?$/i.test(p))
  if (!plain) return ''
  return plain.length > max ? `${plain.slice(0, max - 1).trimEnd()}…` : plain
}

/** brief — краткий итог от агента; иначе текст взят из начала подробного отчёта. */
export function outcomeText(t: Pick<Task, 'summary' | 'result'>): { text: string; brief: boolean } {
  if (t.summary?.trim()) return { text: t.summary.trim(), brief: true }
  return { text: firstParagraph(t.result ?? ''), brief: false }
}
